import React from 'react';
import propTypes from 'prop-types';
import { CmsComponentGrid } from '@johnlewispartnership/wtr-content-component-library';

const ContentLocation = ({ preloadImages = false, name = 'content-location', ...props }) => (
  <CmsComponentGrid {...props} name={name} asContentLocation preloadImages={preloadImages} />
);

ContentLocation.propTypes = {
  name: propTypes.string,
  preloadImages: propTypes.bool,
};

export default ContentLocation;
